import modular from 'modujs';
import * as modules from './modules';
import { html } from './utils/environment';
import debounce from "./utils/debounce";

const app = new modular({
    modules: modules
});

window.onload = (event) => {
    const $style = document.getElementById("stylesheet");

    if ($style.isLoaded) {
        init();
    } else {
        $style.addEventListener('load', (event) => {
            init();
        });
    }
};

function init() {
    // Bind global events
    bindEvents();

    // First resize
    onResize();

    // Init modules
    app.init(app);

    setTimeout(() => {
        html.classList.add('is-first-hit');
        html.classList.add('is-loaded');
        html.classList.add('is-ready');
        html.classList.remove('is-loading');
    }, 100);
}

////////////////
// Global events
////////////////
function bindEvents() {
    // Resize event
    const resizeEndEvent = new CustomEvent("resizeEnd");
    window.addEventListener(
        "resize",
        debounce(
            () => {
                onResize();
                window.dispatchEvent(resizeEndEvent);
            },
            200,
            false
        )
    );
}

function onResize() {
    let vw = html.offsetWidth * 0.01;
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vw", `${vw}px`);
    document.documentElement.style.setProperty("--vh", `${vh}px`);
}
